import { EntityCard } from "@/components/molecules/EntityCard";
import { Skeleton } from "@/components/ui/skeleton";
import type { UnifiedRow } from "@/components/organisms/RecommendationsSection/adapters/toUnifiedRow";

interface EntityCardGridProps {
  rows: UnifiedRow[];
  onRowClick: (row: UnifiedRow) => void;
  is_loading?: boolean;
  loadingRowCount?: number;
  emptyMessage?: string;
}

export function EntityCardGrid({
  rows,
  onRowClick,
  is_loading = false,
  loadingRowCount = 6,
  emptyMessage = "No data found",
}: EntityCardGridProps) {
  if (is_loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: loadingRowCount }).map((_, i) => (
          <div key={i} className="rounded-md border p-3 space-y-2">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div className="border rounded-md h-24 flex items-center justify-center text-muted-foreground text-sm">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {rows.map((row) => (
        <EntityCard key={`${row.kind}-${row.id}`} row={row} onClick={onRowClick} />
      ))}
    </div>
  );
}
